export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20mysterious%20dark%20crimson%20and%20black%20abstract%20background%20with%20soft%20spotlight%20effect%2C%20cinematic%20atmosphere%2C%20entertainment%20industry%20paparazzi%20theme%2C%20modern%20news%20media%20aesthetic%2C%20dark%20gradient%20with%20subtle%20warm%20tones%20and%20bokeh%20highlights%2C%20high%20contrast%2C%20editorial%20photography%20style%2C%20atmospheric%20depth%20with%20rich%20textures&width=1800&height=1200&seq=hero-bg-2026-01&orientation=landscape"
          alt="吃瓜黑料爆料背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-5">
              <i className="ri-fire-line text-accent-400 text-sm"></i>
              <span className="text-accent-300 text-xs font-medium whitespace-nowrap">实时更新 · 全网瓜料一站汇</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
              吃瓜黑料爆料
              <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium text-white/80 mt-2">
                娱乐圈黑料汇总与明星八卦大集合
              </span>
            </h1>

            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              吃瓜黑料爆料网为您集中汇总娱乐圈最新黑料、明星八卦爆料，涵盖出轨内幕、丑闻细节等热门吃瓜事件合集。
              平台每日更新，深度挖掘事件来龙去脉，让每一条瓜料都有据可查。
              一站式浏览全网瓜料，不错过任何一个重磅爆料。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">12,680+</div>
                <div className="text-white/50 text-xs mt-1">累计瓜料收录</div>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">每日更新</div>
                <div className="text-white/50 text-xs mt-1">7×24小时追踪</div>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">匿名保护</div>
                <div className="text-white/50 text-xs mt-1">投稿隐私安全保障</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer text-center"
              >
                立即浏览瓜料合集
              </a>
              <a
                href="#contact"
                className="w-full sm:w-auto px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white border border-white/30 rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer text-center"
              >
                我要爆料投稿
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none hidden md:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photo%20of%20a%20modern%20smartphone%20screen%20displaying%20entertainment%20news%20headlines%20with%20vibrant%20red%20accents%2C%20floating%20around%20it%20are%20stylized%20news%20cards%20and%20social%20media%20icons%2C%20dark%20dramatic%20background%20with%20soft%20glowing%20particles%2C%20hot%20topic%20labels%20in%20warm%20amber%20tones%2C%20modern%20tech%20news%20aesthetic%2C%20high%20detail%2C%20cinematic%20lighting&width=800&height=1000&seq=hero-visual-2026-01&orientation=portrait"
                alt="吃瓜黑料爆料平台展示"
                className="relative w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}